import { IconButton, Select, TextField, styled } from '@mui/material';
import { TableWrapper as SharedTableWrapper } from '../sharedTable.styled';

// Sticky-table chrome lives in the parent Scorecard folder so the ViewScorecard
// `AllocatedProjects` table can reuse the same look.
export { Table, RemoveButton, Dash } from '../sharedTable.styled';

export const TableWrapper = styled(SharedTableWrapper)({
  '&:hover .subgoal-drag-handle, &:focus-within .subgoal-drag-handle': {
    opacity: 1,
  },
});

export const RowDragHandle = styled(IconButton)({
  position: 'absolute',
  left: 8,
  top: 8,
  width: 20,
  height: 40,
  padding: 0,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#6E7071',
  cursor: 'grab',
  touchAction: 'none',
  opacity: 0,
  transition: 'opacity 120ms',
  '&:active': {
    cursor: 'grabbing',
  },
});
RowDragHandle.defaultProps = { className: 'subgoal-drag-handle' };

export const SubgoalNameCell = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
  width: 530,
  minWidth: 530,
});

export const WeightField = styled(TextField)({
  maxWidth: 90,
});

export const FormatSelect = styled(Select)({
  width: 150,
  minWidth: 150,
});

export const SubgoalNameText = styled('span')({
  fontSize: 14,
  lineHeight: '22px',
  fontWeight: 700,
  color: '#010203',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const SubgoalNameHint = styled('span')({
  fontSize: 12,
  lineHeight: '20px',
  fontWeight: 400,
  color: '#515455',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});
